import { ProgressIndicator } from "@9amhealth/shared";
import styled from "@emotion/styled";
import type { FC } from "react";
import React from "react";
import Translate from "src/ui/components/Translate/Translate";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding: 2em;
`;

const QuestionnaireSavingState: FC = () => {
  return (
    <Container role="status" aria-label="Saving">
      <ProgressIndicator indeterminate>
        <p className="as-subhead2 color-c-80">
          <Translate msg="processingInformation" />
        </p>
      </ProgressIndicator>
    </Container>
  );
};

export default QuestionnaireSavingState;
